<div id="graph-toolbar">
  <mat-slide-toggle
    [checked]="checked()"
    (change)="toggleChange($event)"
    color="primary"
    >Disable Zoom</mat-slide-toggle
  >
  <app-mat-icon-button
    buttonStyle="grey"
    iconName="zoom_in"
    (buttonClicked)="zoomIn()"
    ariaLabel="Zoom in"
  ></app-mat-icon-button>
  <app-mat-icon-button
    buttonStyle="grey"
    iconName="zoom_out"
    (buttonClicked)="zoomOut()"
    ariaLabel="Zoom out"
  ></app-mat-icon-button>
  <app-mat-icon-button
    buttonStyle="grey"
    iconName="crop_free"
    (buttonClicked)="setDragMode('zoom')"
    ariaLabel="Box zoom"
    [buttonStyle]="dragMode() === 'zoom' ? 'selected' : 'grey'"
  ></app-mat-icon-button>
  <app-mat-icon-button
    iconName="pan_tool"
    (buttonClicked)="setDragMode('pan')"
    ariaLabel="Pan"
    [buttonStyle]="dragMode() === 'pan' ? 'selected' : 'grey'"
  ></app-mat-icon-button>
  <span class="toolbar-divider"></span>
  <span class="toolbar-divider"></span>
  <app-mat-icon-button
    buttonStyle="grey"
    iconName="download"
    (buttonClicked)="downloadImage()"
    ariaLabel="Download as PNG"
  ></app-mat-icon-button>
  <app-mat-icon-button
    buttonStyle="grey"
    iconName="refresh"
    (buttonClicked)="resetZoom()"
    ariaLabel="Auto scale"
  ></app-mat-icon-button>
</div>
<figure [id]="graphId()">
  <div #plotlyDiv></div>
</figure>
